import { Box, Stack, Typography, Button as MuiButton } from '@mui/material';

import { Button } from '@karehero/llama/components/atoms/Button/Button';

import StatusBar from '@/designs-dev/device/StatusBar';
import AppBar from '@/karehero-app/shell/AppBar';
import ScreenRoot from '@/components/wrapped/ScreenRoot';

// Stub for the form / tool flows that aren't designed yet — back bar, centred
// label, Continue / Previous footer (per the Figma flow placeholders).
const FlowPlaceholder = ({
  title,
  onBack,
}: {
  title: string;
  onBack: () => void;
}) => (
  <ScreenRoot>
    <StatusBar />

    <AppBar onBack={onBack} />

    <Box
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
      }}
    >
      <Typography variant='body1' color='text.secondary'>
        {title}
      </Typography>
    </Box>

    <Stack sx={{ px: 2, pb: 3, flexShrink: 0 }} spacing={2}>
      <Button variant='primary' size='lg' isFullWidth ariaLabel='Continue'>
        Continue
      </Button>
      <MuiButton
        fullWidth
        size='large'
        variant='outlined'
        color='primary'
        onClick={onBack}
      >
        Previous
      </MuiButton>
    </Stack>
  </ScreenRoot>
);

export default FlowPlaceholder;
